import { useState, useEffect, useRef, useCallback } from "react";
import * as signalR from "@microsoft/signalr";

// Construir URL de SignalR correctamente
const getHubUrl = () => {
  const baseUrl = import.meta.env.VITE_API_QUINIELA || "/api";
  // Reemplazar /api con /hubs/chat
  const apiBase = baseUrl.replace(/\/api\/?$/, "");
  return `${apiBase}/hubs/chat`;
};

const HUB_URL = getHubUrl();

export const useChat = (token) => {
  const [messages, setMessages]     = useState([]);
  const [connected, setConnected]   = useState(false);
  const [userEvents, setUserEvents] = useState(null); // { type: "joined"|"left", name }
  const connectionRef = useRef(null);

  useEffect(() => {
    if (!token) return;

    console.log("[Chat] Conectando a:", HUB_URL);

    const connection = new signalR.HubConnectionBuilder()
      .withUrl(HUB_URL, {
        accessTokenFactory: () => token,
        skipNegotiation: false,  // Necesitamos negociación para múltiples transports
        transport: signalR.HttpTransportType.WebSockets |
                   signalR.HttpTransportType.LongPolling,
        withCredentials: false,
      })
      .withAutomaticReconnect([0, 2000, 5000, 10000])
      .configureLogging(signalR.LogLevel.Information)
      .build();

    connection.on("ReceiveMessage", (payload) => {
      setMessages((prev) => [...prev.slice(-199), { ...payload, id: Date.now() + Math.random() }]);
    });

    connection.on("UserJoined", (name) => {
      setUserEvents({ type: "joined", name });
    });

    connection.on("UserLeft", (name) => {
      setUserEvents({ type: "left", name });
    });

    connection.onreconnecting(() => {
      console.log("[Chat] Reconectando...");
      setConnected(false);
    });
    connection.onreconnected(() => {
      console.log("[Chat] Reconectado exitosamente");
      setConnected(true);
    });
    connection.onclose(() => {
      console.log("[Chat] Conexión cerrada");
      setConnected(false);
    });

    connection.start()
      .then(() => {
        console.log("[Chat] Conectado exitosamente");
        setConnected(true);
      })
      .catch((err) => {
        // El transporte inicial podría fallar (ej: WebSocket) pero fallback a LongPolling es normal
        console.warn("[Chat] Intento inicial de conexión:", err.message);
      });

    connectionRef.current = connection;

    return () => {
      connection.stop();
    };
  }, [token]);

  const sendMessage = useCallback(async (text) => {
    if (!connectionRef.current || connectionRef.current.state !== signalR.HubConnectionState.Connected)
      return;
    if (!text?.trim()) return;
    await connectionRef.current.invoke("SendMessage", text.trim());
  }, []);

  return { messages, connected, userEvents, sendMessage };
};
